import { set } from 'lodash';

export default {
  setFormStep({ commit }: any, value: number): void {
    commit('SET_FORM_STEP', value);
  },

  setForm({ commit }: any, value: number): void {
    commit('SET_FORM', value);
  },

  setDocumentosPorRegra({ commit }: any, value: number): void {
    commit('SET_DOCUMENTOS_POR_REGRA', value);
  },
  setDocumentosPorTipoSolicitacao({ commit }: any, value: number): void {
    commit('SET_DOCUMENTOS_POR_SOLICITACAO', value);
  },
  setFormArquivos({ commit }: any, value: number): void {
    commit('SET_FORM_ARQUIVOS', value);
  },
  resetForm({ commit }: any): void {
    commit('RESET_FORM');
  },
  setPossuiSolicitacaoEmAndamento({ commit }: any, value: boolean): void {
    commit('SET_POSSUI_SOLICITACAO_EM_ANDAMENTO', value);
  },
  setRecaptcha({ commit }: any, value: string): void {
    commit('SET_RECAPTCHA', value);
  },
  setPossuiAutorizacaoConsumidorCativo({ commit }: any, value: boolean): void {
    commit('SET_POSSUI_AUTORIZACAO_CONSUMIDOR_CATIVO', value);
  },
  setDadosRecuperadosPreAnalise({ commit }: any, value: any): void {
    commit('SET_DADOS_RECUPERADOS_PRE_ANALISE', value);
  },
  setSolicitacaoPreAprovada({ commit }: any, value: any): void {
    commit('SET_SOLICITACAO_PRE_APROVADA', value);
  },
};
